import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //路由切換
    isRouterChange: false,
    // 事件詳情
    eventDetail: null,
    // 事件id
    eventId: null,
    // 活動id
    activityId: null,
    // 活動詳情
    activityDetail: null,
  },
  getters: {},
  mutations: {
    setIsRouterChange(state) {
      state.isRouterChange = !state.isRouterChange;
    },
    setEvent(state, event) {
      state.eventDetail = event;
      state.eventId = event.id;
    },
    setActivity(state, activity) {
      state.activityDetail = activity;
      state.activityId = activity.id;
    },
  },
  actions: {},
  modules: {},
});
